module.exports = __webpack_public_path__ + "img/map_treasure_c.15c45d2e.svg";